import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IoCTypeOptionsList } from '../../../../../utils/actors';
import { ContentContainer } from '../../../../../components/Filters/components/ContentContainer';
import { ControlsPanel } from '../../../../../components/Filters/components/ControlsPanel';
import { CheckboxList } from '../../../../../components/Filters/components/CheckboxList';
import { useBreakdownsFilterContext } from '../BreakdownsFilterContext';

export const IoCChooser = () => {
  const { t } = useTranslation();
  const { state, updateDraftFilters } = useBreakdownsFilterContext();

  const IoCTypeList = IoCTypeOptionsList(t);
  const selected = state.draftFilters.discreditations.value;

  const handleSelectAll = () => {
    updateDraftFilters({
      discreditations: {
        value: IoCTypeList.map(ioc => ioc.value),
        exclude: state.draftFilters.discreditations.exclude,
      },
    });
  };

  const handleClearAll = () => {
    updateDraftFilters({ discreditations: { value: [], exclude: false } });
  };

  const handleToggleIoCType = (iocValue) => {
    if (selected.includes(iocValue)) {
      updateDraftFilters({
        discreditations: {
          value: selected.filter(ioc => ioc !== iocValue),
          exclude: state.draftFilters.discreditations.exclude,
        },
      });
    } else {
      updateDraftFilters({
        discreditations: {
          value: [...selected, iocValue],
          exclude: state.draftFilters.discreditations.exclude,
        },
      });
    }
  };

  const checkboxItems = useMemo(() => {
    return IoCTypeList.map(iocType => ({
      name: iocType.label,
      checked: selected.includes(iocType.value),
      onChange: () => handleToggleIoCType(iocType.value),
      disabled: false,
      icon: null,
    }));
  }, [IoCTypeList, selected]);

  return (
    <ContentContainer
      actionsComponent={
        <ControlsPanel
          id="breakdown-discreditations-filter"
          count={selected.length}
          isExclude={state.draftFilters.discreditations.exclude}
          isSelectAllDisabled={selected.length === IoCTypeList.length}
          showExcludeSwitch={true}
          showSelectAll={true}
          onClearAll={handleClearAll}
          onSelectAll={handleSelectAll}
          onExcludeClick={() => {
            updateDraftFilters({
              discreditations: {
                value: selected,
                exclude: !state.draftFilters.discreditations.exclude,
              },
            });
          }}
        />
      }
    >
      <CheckboxList items={checkboxItems} />
    </ContentContainer>
  );
};
